import { FC } from 'react';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { Box, Text } from '@wix/design-system';
import { FavoriteFilledSmall } from '@wix/wix-ui-icons-common';
import s from './ReviewsHeader.module.scss';
import { ReviewsMainHeaderProps } from '../../../Reviews/types';

interface ReviewsHeaderProps extends ReviewsMainHeaderProps {}

const ReviewsHeader: FC<ReviewsHeaderProps> = ({
  title,
  isMobileView,
  reviewsCount,
  averageReviewRating,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const textSize = isMobileView ? 'small' : 'medium';

  return (
    <Box
      direction="horizontal"
      gap="SP2"
      marginBottom={isMobileView ? 'SP4' : 'SP5'}
    >
      <Text
        as="h3"
        size={textSize}
        weight="bold"
        dataHook="reviews-header"
        id="reviews-title"
        tabIndex={-1}
      >
        {t(title)}
      </Text>

      <Box verticalAlign="middle" gap="3px">
        <FavoriteFilledSmall />
        <Text size={textSize} weight="bold">
          {Intl.NumberFormat(language, {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
          }).format(averageReviewRating)}
        </Text>
        <Text size={textSize} weight="normal" className={s.textColor}>
          ({reviewsCount})
        </Text>
      </Box>
    </Box>
  );
};

export default ReviewsHeader;
